import { request } from "../../utils/request/request";

export const checkIpBlacklist = async () => {
    const response = await request.get('/blacklist/isBlacklisted');

    return response.data;
};
 